(function () {
  'use strict';

  var activePopup = null;

  // ── Popup show / hide (mirrors plugin-validator.js exactly) ───────

  function lcEscHandler(e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && activePopup) {
      lcHide(activePopup);
    }
  }

  function lcShow(popup) {
    // Load async popup CSS the same way the theme does
    if (typeof new_css === 'function' && window.filepaths && window.filepaths['async_popups_css']) {
      new_css('css-popups', window.filepaths['async_popups_css']);
    }
    activePopup = popup;
    popup.classList.add('shown');
    popup.setAttribute('focusable', 'true');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('popup-shown');
    window.addEventListener('keydown', lcEscHandler);
  }

  function lcHide(popup) {
    popup.classList.remove('shown');
    popup.classList.add('unshown');
    popup.setAttribute('focusable', 'false');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('popup-shown');
    window.removeEventListener('keydown', lcEscHandler);
    setTimeout(function () { popup.classList.remove('unshown'); }, 500);
    activePopup = null;
  }

  // ── Move popup to #root and wrap HTML like semanticPopup() does ───

  function setupPopupStructure(popup) {
    if (popup.dataset.lcStructure) return;
    popup.dataset.lcStructure = '1';

    var id = popup.dataset.title;
    popup.setAttribute('aria-labelledby', id + '-tab');
    popup.setAttribute('aria-describedby', id + '-tab');
    popup.id = id;

    // Wrap exactly as semanticPopup() does
    popup.innerHTML =
      '<div class="box-outer"><div class="box-inner"><div class="box-inset">' +
      popup.innerHTML +
      '<a class="close" href="./">Close</a></div></div>' +
      '<a class="close" href="./">Close</a></div>';

    // Close buttons
    popup.querySelectorAll('.close, button[type="reset"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        lcHide(popup);
      });
    });

    popup.classList.add('ready');
  }

  function moveToRoot(popup) {
    var root = document.getElementById('root');
    if (root && popup.parentElement !== root) {
      root.appendChild(popup);
    }
  }

  // ── Keep the preview in sync with the selected product variant ───

  function getVariantConfig(popup) {
    if (!popup._lcVariantConfig) {
      var data = popup.querySelector('.lc-variant-config');
      popup._lcVariantConfig = data ? JSON.parse(data.textContent) : {};
    }
    return popup._lcVariantConfig;
  }

  function getProductInputs(popup) {
    var formId = popup.dataset.productFormId;
    if (formId) {
      var form = document.getElementById(formId);
      return form ? Array.from(form.elements) : [];
    }
    var mainProduct = document.getElementById('main-product');
    return mainProduct ? Array.from(mainProduct.querySelectorAll('input, select')) : [];
  }

  function getSelectedLeashVariantId(popup) {
    var inputs = getProductInputs(popup);

    // Read current controls first: Shopify replaces the hidden ID only after its AJAX response.
    var selectedOptions = inputs.filter(function (input) {
      return input.matches('input[name^="options"][type="radio"]:checked, select[name^="options"]');
    }).map(function (input) { return input.value; });
    var config = getVariantConfig(popup);
    if (selectedOptions.length && Object.keys(config).length) {
      return Object.keys(config).find(function (id) {
        return config[id].options.length === selectedOptions.length && config[id].options.every(function (value, index) {
          return value === selectedOptions[index];
        });
      }) || '';
    }

    var variantInput = inputs.find(function (input) {
      return input.matches('input[type="hidden"][name="variant-id"], input[type="radio"][name="variant-id"]:checked, select[name="variant-id"]');
    });
    if (variantInput && variantInput.value) return variantInput.value;

    var productIdInput = inputs.find(function (input) {
      return input.matches('input.product-variant-id, input[name="id"]');
    });
    return productIdInput ? productIdInput.value : '';
  }

  function getRenderedVariantId(popup) {
    var inputs = getProductInputs(popup);
    var input = inputs.find(function (input) {
      return input.matches('input[type="hidden"][name="variant-id"]');
    }) || inputs.find(function (input) { return input.matches('input.product-variant-id, input[name="id"]'); });
    return input ? input.value : '';
  }

  function syncLeashPreview(popup, variantId) {
    var previewBar = popup.querySelector('.lc-preview');
    var colorData = popup.querySelector('.lc-leash-variant-colors');
    if (!previewBar || !colorData) return;

    if (!popup._lcVariantColors) {
      try {
        popup._lcVariantColors = JSON.parse(colorData.textContent);
      } catch (err) {
        console.error('[LeashConfigurator] Invalid variant color data', err);
        return;
      }
    }

    if (variantId === undefined) variantId = getSelectedLeashVariantId(popup);
    var selectedColor = popup._lcVariantColors[variantId];
    if (selectedColor) {
      previewBar.setAttribute('data-leash-color', selectedColor);
    }
  }

  // ── Unique-ID helper (prevents line-item merging in Shopify cart) ─

  function generateUid() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }

  // ── Configurator logic ────────────────────────────────────────────

  function initLeashConfigurator(popup) {
    if (popup.dataset.lcInit) return;
    popup.dataset.lcInit = '1';

    var defaultMaxLetters = parseInt(popup.dataset.maxLetters || '8', 10);
    var maxLetters      = defaultMaxLetters;
    var i18nLowStock    = popup.dataset.i18nLowStock || 'Nog {n}';
    var i18nOutOfStock  = popup.dataset.i18nOutOfStock || 'Niet op voorraad';

    var leashDots     = Array.from(popup.querySelectorAll('.lc-dot'));
    var productColorsRow = popup.querySelector('.lc-leash-colors-row');
    var colorOptionIndex = parseInt(popup.dataset.leashColorIndex || '0', 10);
    var overlaysEl    = popup.querySelector('.lc-overlays');
    var countEl       = popup.querySelector('.lc-count');
    var maxCountEl    = popup.querySelector('.lc-max-count');
    var counterEl     = popup.querySelector('.lc-counter');
    var sizePicker    = popup.querySelector('.lc-size-select');
    var sizeOptionIndex = parseInt(popup.dataset.sizeOptionIndex || '-1', 10);
    var sizeHint      = popup.querySelector('.lc-size-hint');
    var largerSizes   = [];
    var limitMessage  = popup.querySelector('.lc-limit-message');
    var limitMessageTemplate = limitMessage ? limitMessage.textContent : '';
    var clearBtn      = popup.querySelector('.lc-clear');
    var charmSwatches = Array.from(popup.querySelectorAll('.lc-charm-swatch'));
    var tiles         = Array.from(popup.querySelectorAll('.lc-tile'));
    var atcBtn        = popup.querySelector('.lc-atc');
    var costOverview  = popup.querySelector('.lc-cost-overview');
    var costValueEl   = popup.querySelector('.lc-cost-value');

    var selectedVariants = [];
    var activeCharmColor = charmSwatches.length ? charmSwatches[0].dataset.charmColor : null;

    // ── Store original disabled state (out-of-stock set in Liquid) ──

    tiles.forEach(function (tile) {
      tile.dataset.originalDisabled = tile.getAttribute('aria-disabled') === 'true' ? 'true' : 'false';
    });

    // Load only the visible colour group, and only after the popup is requested.
    var preloadedCharmColors = {};
    function preloadCharmColor(color) {
      if (!color || preloadedCharmColors[color]) return;
      preloadedCharmColors[color] = true;
      tiles.forEach(function (tile) {
        if (tile.dataset.charmColor !== color) return;
        var src = tile.dataset.image;
        if (src) {
          var img = new Image();
          img.src = src;
        }
      });
    }
    popup._lcPreloadActiveTiles = function () {
      preloadCharmColor(activeCharmColor);
    };

    // ── Product color → page variant picker (preserving size and other options) ──

    function getOptionControls(optionIndex) {
      var inputs = getProductInputs(popup);
      var selected = inputs.filter(function (input) {
        return input.matches('input[name^="options"][type="radio"]:checked, select[name^="options"]');
      });
      var optionInput = selected[optionIndex];
      return optionInput ? inputs.filter(function (input) { return input.name === optionInput.name; }) : [];
    }

    function getColorControls() {
      return getOptionControls(colorOptionIndex);
    }

    function productVariantPending(variantId) {
      var rendered = getRenderedVariantId(popup);
      return productColorsRow && rendered && variantId && rendered !== variantId;
    }

    function syncProductColors(variantId) {
      if (!productColorsRow) return;
      var config = getVariantConfig(popup);
      var variant = config[variantId];
      var controls = getColorControls();
      var options = getProductInputs(popup).filter(function (input) {
        return input.matches('input[name^="options"][type="radio"]:checked, select[name^="options"]');
      }).map(function (input) { return input.value; });
      if (!options.length && variant) options = variant.options;
      var pending = productVariantPending(variantId);
      productColorsRow.setAttribute('aria-busy', pending ? 'true' : 'false');
      leashDots.forEach(function (dot) {
        var color = dot.dataset.leashColorValue;
        var active = options[colorOptionIndex] === color;
        var available = Object.keys(config).some(function (id) {
          return config[id].available !== false && config[id].options.every(function (value, index) {
            return index === colorOptionIndex ? value === color : value === options[index];
          });
        });
        var controllable = controls.some(function (input) {
          return !input.disabled && (input.tagName === 'SELECT' ? Array.from(input.options).some(function (option) {
            return option.value === color && !option.disabled;
          }) : input.value === color);
        });
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        dot.setAttribute('aria-disabled', pending || !available || !controllable ? 'true' : 'false');
      });
    }

    leashDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        syncVariant();
        if (!productColorsRow || dot.getAttribute('aria-disabled') === 'true' || dot.getAttribute('aria-pressed') === 'true') return;
        var color = dot.dataset.leashColorValue;
        var input = getColorControls().find(function (input) {
          return input.tagName === 'SELECT' || input.value === color;
        });
        if (!input) return;
        if (input.tagName === 'SELECT') {
          input.value = color;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.click();
        }
        syncVariant();
      });
    });

    // The single collar can explore a longer mix, but must use a size that fits at checkout.
    function syncSizePicker(variantId) {
      largerSizes = [];
      if (!sizePicker) return;
      var config = getVariantConfig(popup);
      var variant = config[variantId];
      var options = variant ? variant.options : [];
      var controls = getOptionControls(sizeOptionIndex);
      Array.from(sizePicker.options).forEach(function (option) {
        var target = Object.keys(config).map(function (id) { return config[id]; }).find(function (candidate) {
          return candidate.available !== false && candidate.options.every(function (value, index) {
            return value === (index === sizeOptionIndex ? option.value : options[index]);
          });
        });
        var controllable = controls.some(function (input) {
          return !input.disabled && (input.tagName === 'SELECT' ? Array.from(input.options).some(function (item) {
            return item.value === option.value && !item.disabled;
          }) : input.value === option.value);
        });
        option.disabled = !target || !controllable;
        if (!option.disabled && target.maxLetters > maxLetters) {
          largerSizes.push({ size: option.value, max: target.maxLetters });
        }
      });
      sizePicker.value = options[sizeOptionIndex] || '';
      sizePicker.disabled = productVariantPending(variantId) || !controls.length;
    }

    function selectionLimit() {
      return largerSizes.reduce(function (max, item) { return Math.max(max, item.max); }, maxLetters);
    }

    if (sizePicker) {
      sizePicker.addEventListener('change', function () {
        var size = sizePicker.value;
        if (sizePicker.disabled || !sizePicker.selectedOptions.length || sizePicker.selectedOptions[0].disabled) return;
        var input = getOptionControls(sizeOptionIndex).find(function (input) {
          return input.tagName === 'SELECT' || input.value === size;
        });
        if (!input) return;
        if (input.tagName === 'SELECT') {
          input.value = size;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.click();
        }
        syncVariant();
      });
    }

    // ── Charm color → filter tiles ──

    charmSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        activeCharmColor = swatch.dataset.charmColor;
        preloadCharmColor(activeCharmColor);
        charmSwatches.forEach(function (s) {
          var on = s === swatch;
          s.classList.toggle('active', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        tiles.forEach(function (tile) {
          tile.classList.toggle('lc-hidden', tile.dataset.charmColor !== activeCharmColor);
        });
      });
    });

    // ── Counter + state helpers ──

    function updateCounter() {
      var overLimit = selectedVariants.length > maxLetters;
      if (countEl) countEl.textContent = selectedVariants.length;
      if (maxCountEl) maxCountEl.textContent = maxLetters;
      if (counterEl) counterEl.classList.toggle('lc-counter--over-limit', overLimit);
      var showSizeHint = sizeHint && largerSizes.length && selectedVariants.length >= maxLetters;
      if (sizeHint) {
        sizeHint.hidden = !showSizeHint;
        sizeHint.classList.toggle('lc-size-hint--error', overLimit);
        if (showSizeHint) {
          var max = selectionLimit();
          var sizes = largerSizes.filter(function (item) { return item.max === max; }).map(function (item) { return item.size; }).join('/');
          var template = overLimit ? sizeHint.dataset.upgradeTemplate : sizeHint.dataset.capacityTemplate;
          sizeHint.textContent = template.replace('__SIZES__', sizes).replace('__MAX__', max);
        }
      }
      if (limitMessage) {
        limitMessage.textContent = limitMessageTemplate.replace('__MAX__', maxLetters);
        limitMessage.hidden = !overLimit || !!showSizeHint;
      }
    }

    function updateAtcState(variantId) {
      if (!atcBtn) return;
      if (variantId === undefined) variantId = getSelectedLeashVariantId(popup);
      var disabled = !selectedVariants.length || selectedVariants.length > maxLetters ||
        !variantId || (getVariantConfig(popup)[variantId] || {}).available === false ||
        productVariantPending(variantId) || atcBtn.classList.contains('loading');
      atcBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      atcBtn.setAttribute('tabindex', disabled ? '-1' : '0');
    }

    function syncVariant() {
      var variantId = getSelectedLeashVariantId(popup);
      var variant = getVariantConfig(popup)[variantId];
      maxLetters = variant ? variant.maxLetters : defaultMaxLetters;
      syncSizePicker(variantId);
      updateCounter();
      updateTileBadges();
      updateAtcState(variantId);
      syncLeashPreview(popup, variantId);
      syncProductColors(variantId);
    }
    popup._lcSyncVariant = syncVariant;

    function updateCostSummary() {
      if (!costOverview || !costValueEl) return;
      var total = selectedVariants.reduce(function (sum, v) { return sum + (v.price || 0); }, 0);
      if (total === 0) {
        costOverview.hidden = true;
        return;
      }
      costOverview.hidden = false;
      var fmt = function (cents) {
        return (typeof Shopify !== 'undefined' && Shopify.formatMoney)
          ? Shopify.formatMoney(cents)
          : '€' + (cents / 100).toFixed(2);
      };
      var count = selectedVariants.length;
      var allSame = selectedVariants.every(function (v) { return v.price === selectedVariants[0].price; });
      if (allSame && count > 1) {
        costValueEl.textContent = count + ' × ' + fmt(selectedVariants[0].price) + ' = ' + fmt(total);
      } else {
        costValueEl.textContent = fmt(total);
      }
    }

    function redistributeOverlays() {
      // layout handled entirely by CSS (justify-content: center + gap)
    }

    function removeInstance(instanceId) {
      var idx = selectedVariants.findIndex(function (v) { return v.instanceId === instanceId; });
      if (idx !== -1) selectedVariants.splice(idx, 1);
      var wrap = overlaysEl && overlaysEl.querySelector('.lc-overlay-item[data-instance-id="' + instanceId + '"]');
      var restoreFocus = wrap && wrap.contains(document.activeElement);
      if (wrap) wrap.remove();
      redistributeOverlays();
      updateTileBadges();
      updateCounter();
      updateAtcState();
      updateCostSummary();
      if (restoreFocus) {
        var next = overlaysEl.children[Math.min(idx, overlaysEl.children.length - 1)] ||
          tiles.find(function (tile) { return tile.getAttribute('aria-disabled') !== 'true'; }) || clearBtn;
        if (next) next.focus();
      }
    }

    var instanceCounter = 0;

    function addOverlay(instanceId, imageSrc, letter) {
      if (!overlaysEl || !imageSrc) return;

      var wrap = document.createElement('div');
      wrap.className = 'lc-overlay-item';
      wrap.setAttribute('data-instance-id', instanceId);
      wrap.setAttribute('role', 'button');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', (popup.dataset.i18nRemove || 'Remove') + ' ' + (letter || ''));
      wrap.addEventListener('click', function () {
        removeInstance(instanceId);
      });
      addKeyboardClick(wrap);

      var img = document.createElement('img');
      img.src = imageSrc;
      img.alt = '';
      img.draggable = false;
      img.className = 'lc-overlay-img';

      var btn = document.createElement('span');
      btn.className = 'lc-overlay-remove';
      btn.setAttribute('aria-hidden', 'true');
      btn.innerHTML = '<i aria-hidden="true" class="icon-x"></i>';

      wrap.appendChild(img);
      wrap.appendChild(btn);
      overlaysEl.appendChild(wrap);
      redistributeOverlays();
    }

    function updateTileBadges() {
      tiles.forEach(function (tile) {
        var count      = selectedVariants.filter(function (v) { return v.id === tile.dataset.variantId; }).length;
        var stockLimit = tile.dataset.stock !== undefined ? parseInt(tile.dataset.stock, 10) : Infinity;
        var badge      = tile.querySelector('.lc-tile-badge');
        var stockBadge = tile.querySelector('.lc-stock-badge');

        // ── Selection count badge ──
        if (count > 0) {
          tile.classList.add('active');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'lc-tile-badge';
            tile.appendChild(badge);
          }
          badge.textContent = count;
        } else {
          tile.classList.remove('active');
          if (badge) badge.remove();
        }

        // ── Per-variant stock enforcement ──
        var originallyDisabled = tile.dataset.originalDisabled === 'true';
        if (originallyDisabled || count >= stockLimit) {
          tile.setAttribute('aria-disabled', 'true');
          if (!stockBadge) {
            stockBadge = document.createElement('span');
            stockBadge.className = 'lc-stock-badge lc-stock-badge--out';
            tile.appendChild(stockBadge);
          }
          stockBadge.className = 'lc-stock-badge lc-stock-badge--out';
          stockBadge.textContent = i18nOutOfStock;
        } else {
          tile.setAttribute('aria-disabled', selectedVariants.length >= selectionLimit() ? 'true' : 'false');
          var remaining = stockLimit - count;
          if (isFinite(remaining) && remaining <= 5) {
            if (!stockBadge) {
              stockBadge = document.createElement('span');
              stockBadge.className = 'lc-stock-badge lc-stock-badge--low';
              tile.appendChild(stockBadge);
            }
            stockBadge.className = 'lc-stock-badge lc-stock-badge--low';
            stockBadge.textContent = i18nLowStock.replace('{n}', remaining);
          } else {
            if (stockBadge) stockBadge.remove();
          }
        }
      });
    }

    // ── Keyboard support for all role=button divs ──

    function addKeyboardClick(el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.click();
        }
      });
    }

    leashDots.forEach(addKeyboardClick);
    charmSwatches.forEach(addKeyboardClick);
    tiles.forEach(addKeyboardClick);
    if (clearBtn) addKeyboardClick(clearBtn);
    if (atcBtn) addKeyboardClick(atcBtn);

    // ── Tile click — always adds one instance ──

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        syncVariant();
        if (tile.getAttribute('aria-disabled') === 'true') return;
        if (selectedVariants.length >= selectionLimit()) return;

        var variantId  = tile.dataset.variantId;
        var letter     = tile.dataset.letter;
        var imageSrc   = tile.dataset.image;
        var price      = parseInt(tile.dataset.price || '0', 10);
        var instanceId = ++instanceCounter;

        selectedVariants.push({ id: variantId, letter: letter, image: imageSrc, price: price, instanceId: instanceId });
        addOverlay(instanceId, imageSrc, letter);
        updateTileBadges();
        updateCounter();
        updateAtcState();
        updateCostSummary();
      });
    });

    // ── Clear ──

    function clearAll() {
      selectedVariants = [];
      instanceCounter  = 0;
      tiles.forEach(function (tile) {
        tile.classList.remove('active');
        var badge = tile.querySelector('.lc-tile-badge');
        if (badge) badge.remove();
      });
      if (overlaysEl) overlaysEl.innerHTML = '';
      updateTileBadges();
      updateCounter();
      updateAtcState();
      updateCostSummary();
    }

    if (clearBtn) clearBtn.addEventListener('click', clearAll);

    // ── Add to cart ──

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        syncVariant();
        if (atcBtn.getAttribute('aria-disabled') === 'true') return;
        if (!selectedVariants.length) return;
        var leashVariantId = parseInt(getSelectedLeashVariantId(popup), 10);
        if (!leashVariantId) return;

        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.classList.add('loading');

        var items = [{ id: leashVariantId, quantity: 1, properties: { _uid: generateUid() } }];
        selectedVariants.forEach(function (v) {
          items.push({
            id: parseInt(v.id, 10),
            quantity: 1,
            parent_id: leashVariantId,
            properties: { _uid: generateUid() }
          });
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            atcBtn.classList.remove('loading');
            if (data.status && data.status !== 200) throw new Error(data.description || popup.dataset.i18nAddToCartError);
            lcHide(popup);
            if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
              ajaxCart.load(false, true, false, true);
            } else {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
          })
          .catch(function (err) {
            atcBtn.classList.remove('loading');
            updateAtcState();
            console.error('[LeashConfigurator]', err);
            alert(err.message || popup.dataset.i18nAddToCartError);
          });
      });
    }

    // ── Reset when popup closes ──

    var observer = new MutationObserver(function () {
      if (!popup.classList.contains('shown')) clearAll();
    });
    observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
  }

  // ── Entry point ───────────────────────────────────────────────────

  // ── Inject fresh _uid into the product-page form on every submit ──
  // This ensures each regular ATC always creates a new cart line item.

  function hookProductFormUid() {
    var form = document.querySelector('form.f8pr-product-form, form[data-section-id]');
    if (!form || form.dataset.lcUidHooked) return;
    form.dataset.lcUidHooked = '1';
    form.addEventListener('submit', function () {
      var uidInput = form.querySelector('input[name="properties[_uid]"]');
      if (!uidInput) {
        uidInput = document.createElement('input');
        uidInput.type = 'hidden';
        uidInput.name = 'properties[_uid]';
        form.appendChild(uidInput);
      }
      uidInput.value = generateUid();
    }, true /* capture — fires before FormData is collected */);
  }

  function initAll() {
    document.querySelectorAll('.lc-popup').forEach(function (popup) {
      // 1. Move to #root so z-index / overlay works correctly
      moveToRoot(popup);

      // 2. Wrap HTML like semanticPopup() — only once
      setupPopupStructure(popup);

      // 3. Handle current and AJAX-refreshed trigger buttons.
      var popupId = popup.dataset.title;
      if (!popup.dataset.lcTriggerInit) {
        popup.dataset.lcTriggerInit = '1';
        document.addEventListener('click', function (e) {
          var trigger = e.target.closest && e.target.closest('.lc-trigger');
          if (!trigger) return;

          var triggerPopupId = trigger.getAttribute('data-popup');
          if (!triggerPopupId) {
            var href = trigger.getAttribute('href') || '';
            triggerPopupId = href.charAt(0) === '#' ? href.slice(1) : '';
          }
          if (triggerPopupId !== popupId) return;

          e.preventDefault();
          e.stopPropagation();
          if (popup._lcSyncVariant) popup._lcSyncVariant();
          if (popup._lcPreloadActiveTiles) popup._lcPreloadActiveTiles();
          lcShow(popup);
        }, true);
      }

      // 4. Init configurator interaction
      initLeashConfigurator(popup);
      popup._lcSyncVariant();
    });

    // 5. Hook the product-page form so regular ATC also creates unique line items
    hookProductFormUid();
  }

  // Option controls are replaced by the theme's AJAX variant renderer.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('input[name^="options"], select[name^="options"], input[name="variant-id"], select[name="variant-id"]')) return;
    document.querySelectorAll('.lc-popup').forEach(function (popup) {
      var formId = popup.dataset.productFormId;
      if (formId && input.form !== document.getElementById(formId)) return;
      if (!formId && !input.closest('#main-product .f8pr-variant-selection')) return;
      if (popup._lcSyncVariant) popup._lcSyncVariant();
    });
  });
  window.addEventListener('themeVariantUpdated', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
